<script>
import { mapState, mapActions } from 'vuex';
import { throttle } from 'lodash-es';

export default {
  name: 'FerryTableInputs',
  props: {
    disabled: {
      required: true,
      type: Boolean,
    },
    search: {
      default: '',
      type: String,
    },
  },
  computed: {
    ...mapState({
      supplier: state => state.transportation.suppliers.supplier,
      suppliers: state => state.transportation.suppliers.items,
      suppliersLoading: state => state.transportation.suppliers.itemsLoading,
      suppliersError: state => state.transportation.suppliers.itemsError,
    }),
  },
  methods: {
    ...mapActions({
      setSupplier: 'transportation/suppliersSet',
      loadSuppliers: 'transportation/suppliersLoad',
    }),
    throttleInput: throttle(function input(search) {
      this.$emit('search', search);
    }, 250, { leading: false }),
    changeSupplier(supplier) {
      this.setSupplier(supplier);
      this.$emit('change', supplier);
    },
    refreshSuppliers() {
      if (this.suppliersError) {
        this.loadSuppliers();
      }
    },
  },
};
</script>

<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-select
        @input="changeSupplier"
        @click:append="refreshSuppliers"
        :value="supplier"
        :items="suppliers"
        :loading="suppliersLoading"
        :label="$t('transportation.suppliers.title')"
        :disabled="suppliersLoading || disabled"
        :error-messages="suppliersError ? $t('transportation.suppliers.error') : undefined"
        :error="!!suppliersError"
        :append-icon="!suppliersError ? 'arrow_drop_down' : 'refresh'"
        item-value="id"
        dense
        >
        <template slot="item" slot-scope="props">
          <v-list-tile
            two-lines
            @click="props.tile.on.click">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ props.item.internalIdentifier }}
                <span
                  v-if="!props.item.active"
                  class="pl-1 font-italic grey--text text--darken-1">
                  ({{ $t('inputs.misc.inactive') }})
                </span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <template slot="selection" slot-scope="props">
          {{ props.item.internalIdentifier }}
          <span
            v-if="!props.item.active"
            class="pl-1 font-italic grey--text text--lighten-1">
            ({{ $t('inputs.misc.inactive') }})
          </span>
        </template>
      </v-select>
    </v-flex>
    <v-flex xs6 pl-4>
      <v-text-field
        @input="throttleInput"
        :value="search"
        :placeholder="$t('inputs.placeholders.search')"
        clearable
        hide-details
        >
      </v-text-field>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/transportation/TransportationTableInputs.vue